import React from 'react';
import { FadeIn, CTAButton, Section, Accent, Stars } from './Shared';
import { ProductVideo } from './ProductVideo';
import { featuredTestimonials } from '../data/testimonials';
import { ShieldCheck, Lock, BadgeCheckIcon, Star, X, ArrowRightIcon, FileTextIcon, ZapIcon, LayersIcon, TrophyIcon } from 'lucide-react';
export const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/mmxQLTUbFeKMXmGcHhTPx9/MOCKUP_PRINCIPAL.png';
const PRODUCT_VIDEO = 'https://cdn.magicpatterns.com/uploads/ioWtMCT8zXmW9Bh1ASDYsL/video%20libros.mp4';
export const Hero = () => {
  const chips = [{
    icon: FileTextIcon,
    label: '100\u00a0% PDF'
  }, {
    icon: ZapIcon,
    label: 'Accès en 5 min'
  }, {
    icon: LayersIcon,
    label: '365 séances'
  }];
  return <section className="relative overflow-hidden border-b border-white/5 bg-slate-950" data-id="element-283" data-mp="dyr6i69yex8j">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-sky-400/40" aria-hidden="true" data-id="element-284" data-mp="1kgmqsel45kdt" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-[minmax(0,1fr)] items-center justify-items-center gap-3 px-5 pb-10 pt-4 sm:gap-6 sm:pt-8 md:px-8 md:pb-20 md:pt-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:justify-items-stretch lg:gap-x-12 lg:gap-y-8" data-id="element-285" data-mp="1pi3pc3g4kur8">
        {/* Headline */}
        <FadeIn className="flex w-full min-w-0 flex-col items-center text-center lg:col-start-1 lg:row-start-1 lg:items-start lg:self-end lg:text-left" data-id="element-286" data-mp="18bqk01k4v8dw">
          <p className="mb-2 flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-sky-400 sm:mb-4 sm:text-xs" data-id="element-287" data-mp="ybputyzl1y1s">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-sky-400" aria-hidden="true" data-id="element-288" data-mp="tiwt7jzev5tx" />
            FITNESS FONCTIONNEL 365™
          </p>
          <h1 className="w-full break-words pr-[0.06em] font-display text-[clamp(26px,8vw,40px)] font-black uppercase italic leading-[1.02] tracking-tight text-white sm:text-5xl md:text-6xl lg:pr-0 lg:text-[60px]" data-id="element-289" data-mp="kkun4q0tlmzs">
            Organisez tous vos cours de <Accent data-id="element-290" data-mp="anyk2ztoxt2m">fonctionnel.</Accent>
            <span className="mt-1 block text-slate-400" data-id="element-291" data-mp="xqanxq784by">En 5 minutes.</span>
          </h1>
          <p className="mx-auto mt-2.5 max-w-[340px] text-[13.5px] leading-snug text-slate-300 sm:mt-5 sm:max-w-md sm:text-base sm:leading-relaxed md:text-lg lg:mx-0" data-id="element-292" data-mp="5x2zup4jlnhp">
            Votre système complet d’entraînement fonctionnel&nbsp;: 365 jours de séances,
            échauffements, circuits, progressions et planification prêts à l’emploi.
          </p>
        </FadeIn>

        {/* Mockup */}
        <FadeIn delay={0.05} className="flex w-full min-w-0 justify-center lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-293" data-mp="onklyauvdku3">
          <a href="#pricing" className="group block w-full" aria-label="Voir l’offre" data-id="element-294" data-mp="9zpqimph92db">
            <img src={HERO_MOCKUP} alt="FITNESS FONCTIONNEL 365 — les 6 tomes, le pack de bonus et l’accès digital sur tablette, ordinateur et téléphone" width={1536} height={1024} loading="eager" decoding="async"
          // @ts-ignore fetchpriority is valid HTML
          fetchpriority="high" className="mx-auto block h-auto w-full max-w-[380px] object-contain transition-transform duration-200 ease-out group-hover:-translate-y-1 sm:max-w-[560px] lg:max-w-none" data-id="element-295" data-mp="exivjcf1nqc0" />
          </a>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.1} className="flex w-full min-w-0 max-w-[420px] flex-col items-center sm:max-w-none lg:col-start-1 lg:row-start-2 lg:items-start lg:self-start" data-id="element-296" data-mp="31tim78iffjdo">
          <ul className="mb-3 flex w-full flex-wrap items-center justify-center gap-1.5 sm:mb-5 sm:gap-2 lg:justify-start" data-id="element-297" data-mp="295mvckfjglot">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-[11px] font-medium text-slate-200 sm:gap-1.5 sm:px-3 sm:py-1.5 sm:text-xs md:text-sm" data-id="element-298" data-mp="2i6b9df4xmm1p">
                <Icon size={14} className="text-sky-400" aria-hidden="true" data-id="element-299" data-mp="3tk57ih3sn8t5" />
                {label}
              </li>)}
          </ul>
          <CTAButton href="#pricing" className="w-full sm:w-auto" data-id="element-300" data-mp="3pmh7izn8upue">
            Je le veux maintenant
            <ArrowRightIcon size={18} className="transition-transform duration-200 group-hover/cta:translate-x-0.5" aria-hidden="true" data-id="element-301" data-mp="or9q66yhad6h" />
          </CTAButton>
          <div className="mt-3 flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center text-[11px] text-slate-400 sm:mt-4 sm:gap-x-4 sm:text-xs lg:justify-start" data-id="element-302" data-mp="xoty1yquj7q2">
            <span className="flex items-center gap-1.5" data-id="element-303" data-mp="17mq6ujwb9ql0">
              <ShieldCheck size={14} className="text-emerald-400" aria-hidden="true" data-id="element-304" data-mp="1bpd26us6xtmy" /> Garantie 7 jours
            </span>
            <span className="flex items-center gap-1.5" data-id="element-305" data-mp="1gfl3ip7pqdz6">
              <Lock size={14} aria-hidden="true" data-id="element-306" data-mp="1gi65de80gtwx" /> Paiement sécurisé
            </span>
            <span className="flex items-center gap-1.5" data-id="element-307" data-mp="1leefueb9jyxr">
              <BadgeCheckIcon size={14} className="text-sky-400" aria-hidden="true" data-id="element-308" data-mp="1qf262xro4bqx" /> Sans frais cachés
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'coachs conquis'
  }, {
    value: '6',
    label: 'Tomes complets'
  }, {
    value: '5',
    label: 'Bonus inclus'
  }, {
    value: '4,9/5',
    label: 'note moyenne',
    star: true
  }];
  return <div className="border-b border-white/5 bg-slate-900/40 px-5 py-8 md:px-8" data-id="element-309" data-mp="35z1p57co75nl">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-6 md:grid-cols-4" data-id="element-310" data-mp="30zyijih1krdi">
        {stats.map((s, i) => <div key={s.label} className={`text-center ${i % 2 === 1 ? 'border-l border-white/10' : ''} ${i > 0 ? 'md:border-l md:border-white/10' : ''}`} data-id="element-311" data-mp="2ikupb1dyx82" data-mpi={i}>
            <dt className="sr-only" data-id="element-312" data-mp="3ovb03ls9zg3d">{s.label}</dt>
            <dd className="font-display text-4xl font-black italic leading-none tracking-tight text-white md:text-5xl" data-id="element-313" data-mp="3ou007x1yashj">
              {s.value}
            </dd>
            <dd className="mt-2 flex items-center justify-center gap-1 text-sm text-slate-400" data-id="element-314" data-mp="l7rhpa97qazo">
              {s.label}
              {s.star && <Star size={12} className="fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-315" data-mp="ge6ft74i0wv7" />}
            </dd>
          </div>)}
      </dl>
    </div>;
};
export const Testimonials1 = () => <Section className="bg-slate-950 !py-12 md:!py-16" data-id="element-316" data-mp="2fmok5n7dyk1a">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-317" data-mp="20ylfch52xee2">
      {featuredTestimonials.map((t, i) => <FadeIn key={t.author} delay={Math.min(i * 0.05, 0.15)} data-id="element-318" data-mp="25x51ahjoaq6f" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6" data-id="element-319" data-mp="25vbpyoy47hs3">
            <Stars data-id="element-320" data-mp="1vz8qxryk7z9d" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-321" data-mp="1vzqkggtu7zdl">
              «&nbsp;{t.text}&nbsp;»
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-322" data-mp="1i1ae4qzw0avz">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-323" data-mp="1mzln6zicyhd5">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-324" data-mp="3hctnh6p3rl66">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-325" data-mp="3hbsauxsfuqmc">{t.author}</p>
                <p className="text-xs text-slate-500" data-id="element-326" data-mp="15pq2vpd2ygbq">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Problem = () => {
  const painPoints = ['Vous arrivez à la salle sans savoir exactement quel cours donner aujourd’hui.', 'Vous perdez des heures à chercher des exercices, monter des circuits et réfléchir à comment les adapter à tout votre groupe.', 'Vous finissez par répéter les mêmes entraînements faute d’avoir assez de séances prêtes.', 'Vous voulez un programme annuel structuré, mais vous n’avez pas le temps de le planifier.', 'Vous cherchez plus de variété et de progression, mais vous sentez que votre groupe stagne.', 'Le week-end à chercher des idées. Le lundi, tout semble improvisé. Et le cycle recommence.'];
  return <Section className="bg-slate-900/40" data-id="element-327" data-mp="404ldxo4wnq5">
      <FadeIn className="mx-auto mb-10 max-w-4xl text-center md:mb-14" data-id="element-328" data-mp="3v6ff18qtem7g">
        <h2 className="mx-auto font-display text-[28px] font-black uppercase italic leading-[1.08] tracking-tight text-white sm:text-[44px] md:text-[60px] lg:text-[68px]" data-id="element-329" data-mp="3v8ieejduxrou">
          Si vous êtes coach de <Accent data-id="element-330" data-mp="3ea04v4xe2vli">fonctionnel,</Accent>
          <br data-id="element-331" data-mp="3j29uejuldtn9" /> ça va vous parler…
        </h2>
      </FadeIn>

      <ul className="mx-auto mb-16 grid max-w-4xl grid-cols-1 gap-x-8 md:mb-24 md:grid-cols-2" data-id="element-332" data-mp="3j55q01iyw68j">
        {painPoints.map(point => <li key={point} className="flex items-start gap-3 border-b border-white/5 py-3.5" data-id="element-333" data-mp="2qedwjbtadvow">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-334" data-mp="2vd79n34nvkoj">
              <X size={12} className="text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-335" data-mp="30bsczbf7mkh7" />
            </span>
            <p className="text-[15px] leading-normal text-slate-300 md:text-base" data-id="element-336" data-mp="34e5ipztyiidz">{point}</p>
          </li>)}
      </ul>

      <FadeIn className="mx-auto mb-12 max-w-3xl text-center md:mb-16" data-id="element-337" data-mp="flb2xootn2yr">
        <h3 className="mx-auto pr-[0.06em] font-display text-[clamp(26px,8vw,34px)] font-black uppercase italic leading-[1.08] tracking-tight text-white sm:text-[42px] md:text-[56px] lg:text-[64px]" data-id="element-338" data-mp="jn4zplvwbmtn">
          <span className="block sm:inline" data-id="element-339" data-mp="203lp7q5m594o">Vous</span>{' '}
          <span className="block sm:inline" data-id="element-340" data-mp="20682m6f6qiut">improvisez encore</span>{' '}
          <span className="block sm:inline" data-id="element-341" data-mp="1vbu4hw951xmg">vos</span>{' '}
          <span className="block whitespace-nowrap sm:inline" data-id="element-342" data-mp="1qetytmg7awvv">
            <Accent data-id="element-343" data-mp="1qc7pbh9r27b0">entraînements&nbsp;?</Accent>
          </span>
        </h3>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-[15px] leading-relaxed text-slate-300 md:mt-8 md:text-lg" data-id="element-344" data-mp="1lgsg52moszkx">
          <p data-id="element-345" data-mp="1gi8qos8vx5nt">
            Vous avez choisi ce métier parce que l’entraînement fonctionnel vous
            passionne et que vous aimez voir votre groupe progresser.
          </p>
          <p data-id="element-346" data-mp="17h0z0t0vj32p">
            Que vous ayez des années d’expérience ou que vous débutiez&nbsp;:{' '}
            <span className="text-white" data-id="element-347" data-mp="36s22rlhjemsb">le problème est souvent le même.</span>
          </p>
          <p data-id="element-348" data-mp="31u0i4w4gqfeq">
            Vous passez plus de temps à <strong className="font-semibold text-white" data-id="element-349" data-mp="ibmwcpwitu3d">CHERCHER</strong> quoi
            enseigner qu’à réellement <strong className="font-semibold text-white" data-id="element-350" data-mp="dcttrsirvnhz">ENSEIGNER</strong>.
          </p>
          <p data-id="element-351" data-mp="rccp1kqhj4cv">
            Et pendant que vous sacrifiez vos dimanches à préparer vos cours, d’autres
            coachs prennent de l’avance.
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mx-auto max-w-3xl" data-id="element-352" data-mp="mb5fph8p1x43">
        <div className="rounded-3xl border border-sky-400/40 bg-blue-600/10 px-6 py-8 text-center md:px-10 md:py-10" data-id="element-353" data-mp="3usa3i5voiyh0">
          <p className="font-display text-2xl font-black uppercase italic leading-[1.1] tracking-tight text-white md:text-4xl" data-id="element-354" data-mp="3qsrfv2ch49ah">
            Et si c’était le <Accent data-id="element-355" data-mp="3mqs73xl5181">dernier cours</Accent>
            <br data-id="element-356" data-mp="3lpeerp6q0mm" /> que vous prépariez comme ça&nbsp;?
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mt-20 text-center md:mt-28" data-id="element-357" data-mp="3c1sfgelskr1z">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-amber-950" data-id="element-358" data-mp="3c07iyjfx2y1h">
          <TrophyIcon size={14} aria-hidden="true" data-id="element-359" data-mp="1mkn26nwvpq0v" />
          Le système n°1 des coachs fonctionnels
        </p>
        <h2 className="font-display text-4xl font-black uppercase italic leading-[1.05] tracking-tight text-white md:text-6xl" data-id="element-360" data-mp="1rdq0188ovlmv">
          Fitness Fonctionnel <Accent data-id="element-361" data-mp="1ijl8emlqe66a">365™</Accent>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-362" data-mp="1ikcv17xcotkf">
          6 Tomes + 5 Bonus — 365 séances prêtes · Une année complète · Tout est réglé.
        </p>

        <div className="relative mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-slate-900 shadow-2xl shadow-black/50" data-id="element-363" data-mp="2aahd2zxn14ih">
          <ProductVideo src={PRODUCT_VIDEO} label="Aperçu des tomes de FITNESS FONCTIONNEL 365" className="block w-full object-cover" data-id="element-364" data-mp="21a2qlx8xtjde" />
        </div>
      </FadeIn>
    </Section>;
};